var SCM = SCM || {};

SCM.SplitScreenFiguresAndTables = (function (ns, elementManager, splitScreenHelper) {

    return {
        runVideoJsFixups: runVideoJsFixups,
        getFigures: getFigures,
        getTables: getTables,
        scrollInFiguresAndTablesSplitView: scrollInFiguresAndTablesSplitView
    };

    /**
     * If there are any graphical abstact figures within a graphical abstract section,
     * replace the graphical abstract figure id with the graphical abstract section id.
     * @param {any} graphicalAbstractSection   The graphical abstract element.
     * @param {any} figures                    An array of figure elements.
     */
    function replaceGraphicalAbstractFigId(graphicalAbstractSection, figures) {
        if (graphicalAbstractSection) {
            var graphicalAbstractFigSection = elementManager.getFirstElementByClassName(graphicalAbstractSection, 'fig-section');
            if (graphicalAbstractFigSection) {
                var graphicalAbstractFigId = graphicalAbstractFigSection.dataset.id;

                for (var i = 0; i < figures.length; i++) {
                    if (figures[i].dataset.id === graphicalAbstractFigId) {
                        figures[i] = graphicalAbstractSection;
                        break;
                    }
                }
            }
        }
    }

    function runVideoJsFixups (widget) {
        var videos = widget.getElementsByClassName('video-js');
        for (var i = 0; i < videos.length; i++) {
            var video = videos[i];
            var replacementVideo = elementManager.createElement('video', {
                'data-account': video.dataset.account,
                'data-player': video.dataset.player,
                'data-embed': video.dataset.embed,
                'class': 'brightcove-player video-js',
                'controls': '',
                'data-video-id': video.dataset.videoId
            });

            video.parentNode.replaceChild(replacementVideo, video);
        }
        SCM.Utilities.Brightcove.init();
    }

    function getFigures(contentFullText) {
        var graphicalAbstractSection = elementManager.getFirstElementByClassName(contentFullText, 'graphicalAbstract');

        var figures = elementManager.getElementsByClassList(contentFullText, [
            'figure-title',
            'fig-section',
            'js-splitscreen-figure-title',
            'js-sec-fig-section',
            'js-p-fig-section']);

        replaceGraphicalAbstractFigId(graphicalAbstractSection, figures);
        
        return figures;
    }

    function getTables(contentFullText) {
        // js-jumpLoc-legacySectionId is used on multiple <span> tags in chapters (not just for tables). 
        // Tables have no identifier in chapter xml, so the jumpLoc-legacySectionId span tags are needed 
        // to allow these table links to function in split-view.
        var tables = elementManager.getElementsByClassList(contentFullText, [
            'js-splitscreen-tablegroup-title',
            'table-full-width-wrap',
            'jumpLoc-legacySectionId']);
        // I am not sure why we would have multiple tables with the same ids, 
        // but this is existing code for article split view.
        if (splitScreenHelper.isArticlePage()) {
            splitScreenHelper.removeDuplicateItemsBasedOnId(tables);
        }

        return tables;
    }

    function scrollInFiguresAndTablesSplitView(id, scrollablePanel) {
        var figTable = $(scrollablePanel).find('[data-id="' + id + '"]');
        if (!figTable.length) {
           figTable = $(scrollablePanel).find('[data-id="' + id.toLowerCase() + '"]');
        }
        if (figTable.length) {
            scrollablePanel.switchTo();
            scrollablePanel.scrollTop = figTable[0].offsetTop;
        }
        return;
    }

})(SCM.SplitScreenFiguresAndTables = SCM.SplitScreenFiguresAndTables || {}, SCM.ElementManager, SCM.SplitScreenHelper);